import React from "react";
import { Row, Col, Typography, Space, Button, Modal } from "antd";
import Styles from "./NotCoverageZipPopup.module.scss";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { GeneralDefinition } from "../../../../types/ApplicationTypes";
import { usePlanDetailsCtx } from "../../../../context/PlanDetailsContext";

type Props = {
  isNotCovergeZip: boolean;
  handleCancelCoverage: () => void;
};

const NotCoverageZipPopup: React.FC<Props> = ({
  isNotCovergeZip,
  handleCancelCoverage,
}) => {
  const { width } = useWindowSize();
  const { tripDetailsInfo } = usePlanDetailsCtx();

  return width > GeneralDefinition.MobileView ? (
    <Modal
      onCancel={handleCancelCoverage}
      visible={isNotCovergeZip}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      centered={true}
      footer={
        <Row className={Styles.modalContainer}>
          <Col span={24}>
            <Row justify="center">
              <Typography.Text className={Styles.modalHeaderClose}>
                Address Verification Required
              </Typography.Text>
            </Row>
            <Row justify="center" className={Styles.covergeSection}>
              <Col>
                <Row justify="center">
                  <Col className={Styles.modalBodyText}>
                    The dropoff address will need to be
                  </Col>
                </Row>
                <Row justify="center">
                  <Col className={Styles.modalBodyText}>
                    verified before continuing.
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row justify="center" className={Styles.covergeSection}>
              <Col>
                <Row justify="center">
                  <Col className={Styles.modalBodyText}>
                    Please contact us at{" "}
                    {tripDetailsInfo.wandaCustomerCareNumber}
                    for
                  </Col>
                </Row>
                <Row justify="center">
                  <Col className={Styles.modalBodyText}>assistance.</Col>
                </Row>
              </Col>
            </Row>
            <Row justify="center" className={Styles.covergeSection}>
              <Col className={Styles.modalBtn}>
                <Space>
                  <Button
                    className={Styles.buttonThemeBlueClose}
                    onClick={handleCancelCoverage}
                  >
                    Close
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  ) : (
    <Modal
      onCancel={handleCancelCoverage}
      visible={isNotCovergeZip}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      centered={true}
      footer={
        <Row className={Styles.modalContainer}>
          <Col span={24}>
            <Row justify="center">
              <Typography.Text className={Styles.modalHeaderClose}>
                Address Verification Required
              </Typography.Text>
            </Row>
            <Row justify="center" className={Styles.covergeSection}>
              <Col>
                <Row justify="center">
                  <Col className={Styles.modalBodyText}>
                    The dropoff address will need to be verified before
                    continuing.
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row justify="center" className={Styles.covergeSection}>
              <Col>
                <Row justify="center">
                  <Col className={Styles.modalBodyText}>
                    Please contact us at{" "}
                    {tripDetailsInfo.wandaCustomerCareNumber}
                    for assistance.
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row justify="center" className={Styles.covergeSection}>
              <Col className={Styles.modalBtn}>
                <Space>
                  <Button
                    className={Styles.buttonThemeBlueClose}
                    onClick={handleCancelCoverage}
                  >
                    Close
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  );
};

export default NotCoverageZipPopup;
